
import {Component, Vue, Prop} from 'vue-property-decorator'
import addClass from '@/views/goodsManage/commodity/subPage/addClass.vue'
import { categoryDto } from '@/api/goods'

@Component({
  components: {
    addClass
  }
})
export default class GoodsCategorySelect extends Vue {
  @Prop({ default: '' }) categoryId?: string
  $refs!: {
    addClass
  }
  visible = false

  showModal () {
    this.visible = true
    this.$nextTick(() => {
      this.$refs.addClass.getInfo()
    })
  }
  handleSelect (data: categoryDto) {
    this.$emit('on-select', data)
    this.visible = false
  }
  handleCancel () {
    this.$refs.addClass.handleCancel()
  }
  handleSure () {
    this.$refs.addClass.handleSave()
  }
}
